import { useTranslation } from 'react-i18next';
import { PageHeader } from '@/components/layout/PageHeader';
import { ICONS } from '@/constants/icons';

/** Header of the Blog list page. Shared with RequireEntitlement so the locked state shows the identical header. */
export const BlogListHeader = ({ backTo, backLabel }: { backTo?: string; backLabel?: string }) => {
  const { t } = useTranslation('common');
  return (
    <PageHeader
      title={t('blog_page_title', { defaultValue: 'Blog' })}
      subtitle={t('blog_page_subtitle', { defaultValue: 'Publish long-form content from Google Docs to your WordPress site' })}
      icon={ICONS.BLOG}
      headerType="list"
      documentTitle={t('blog_page_title', { defaultValue: 'Blog' })}
      backTo={backTo}
      backLabel={backLabel}
    />
  );
};

/** Header of the New Blog Post page. */
export const BlogNewHeader = () => {
  const { t } = useTranslation('common');
  return (
    <PageHeader
      title={t('blog_new_page_title', { defaultValue: 'New Blog Post' })}
      subtitle={t('blog_new_page_subtitle', { defaultValue: 'Pull a Google Doc to draft your blog post' })}
      icon={ICONS.BLOG}
      headerType="list"
      documentTitle={t('blog_new_page_title', { defaultValue: 'New Blog Post' })}
      backTo="/blog"
      backLabel={t('blog_page_title', { defaultValue: 'Blog' })}
    />
  );
};

/** Locked header of a single blog post: the post title is not loaded while locked, so it shows the Blog header with a back link. */
export const BlogDetailLockedHeader = () => {
  const { t } = useTranslation('common');
  return <BlogListHeader backTo="/blog" backLabel={t('blog_page_title', { defaultValue: 'Blog' })} />;
};
